<template>
  <section>
    <h5>{{ picture.code }} {{ picture_name }}</h5>
    <p v-if="picture_author != '-'">{{ picture_author }}</p>
    <p v-if="picture.type_name">{{ picture.type_name }}</p>
    <p v-if="picture_spec != '<p>/</p>'" v-html="picture_spec"></p>
    <p v-if="picture_intro" v-html="picture_intro"></p>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar><br>
  </section>
</template>

<script>
import Vue from 'vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

export default {
  name: 'picture-info',
  props: {
    picture: {
      type: Object,
      require: true
    }
  },
  computed: {
    picture_name() {
      return this.$i18n.locale === 'tw' || !this.picture.english_name
        ? this.picture.chinese_name
        : this.picture.english_name
    },
    picture_author() {
      return this.$i18n.locale === 'tw' || !this.picture.english_author
        ? this.picture.chinese_author
        : this.picture.english_author
    },
    picture_spec() {
      return this.$i18n.locale === 'tw' || !this.picture.english_spec
        ? this.picture.chinese_spec
        : this.picture.english_spec
    },
    picture_intro() {
      return this.$i18n.locale === 'tw' || !this.picture.english_intro
        ? this.picture.chinese_intro
        : this.picture.english_intro
    },
    social_sharing_title() {
      return `${this.picture.code} ${this.picture_name}`
    },
    social_sharing_route() {
      return { name: 'picture', params: { id: this.picture.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.picture && this.picture.id) {
      gtag('event', `browse picture`, {
        code: this.picture.id,
        name: this.picture.chinese_name,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }
}
</script>